import ChannelBill from './ChannelBill.jsx';

export default ChannelBill;